<p *ngIf="loading">Loading...</p>
<p *ngIf="!loading">SurfConext SSO: In a few moments you will be redirected to movielearning, please wait.</p>
<p *ngIf="errors" style="color:red;">Error</p>
<p *ngIf="errors" style="color:red;">{{errors}}</p>

